import { Spinner } from '@frontend/components/common';
import { ScreenType } from '@frontend/wizard/types';

import WizardNavigationHeader from '../components/wizard-navigation-header/wizard-navigation-header.component';
import AuthenticatedDropOffMethod from '../screens/authenticated-drop-off-method/authenticated-drop-off-method.component';
import AuthenticatedPickUpMethod from '../screens/authenticated-pick-up-method/authenticated-pick-up-method.component';
import { BasketOverview } from '../screens/basket-overview/basket-overview.component';
import { BrowseProductsByCategories } from '../screens/browse-products-by-categories/browse-products-by-categories.component';
import ConfirmCurrentDeviceLocation from '../screens/confirm-current-device-location/confirm-current-device-location.component';
import ConfirmCurrentLocation from '../screens/confirm-current-location/confirm-current-location.component';
import { ConfirmKitReturnSlot } from '../screens/confirm-kit-return-slot/confirm-kit-return-slot.component';
import { ConfirmKitReturn } from '../screens/confirm-kit-return/confirm-kit-return.component';
import { ConfirmOrder } from '../screens/confirm-order/confirm-order.component';
import ConfirmPickUp from '../screens/confirm-pick-up/confirm-pick-up.component';
import { ConfirmReturn } from '../screens/confirm-return/confirm-return.component';
import ConfirmShopTransaction from '../screens/confirm-shop-transaction/confirm-shop-transaction.component';
import { ConsumeKit } from '../screens/consume-kit/consume-kit.component';
import ContinueToLocation from '../screens/continue-to-location/continue-to-location.component';
import { CreateAuditTransaction } from '../screens/create-audit-transaction/create-audit-transaction.component';
import CreateReceiver from '../screens/create-receiver/create-receiver.component';
import { CreateRecycleTransaction } from '../screens/create-recycle-transaction/create-recycle-transaction.component';
import DropOffConfirmOpenSlot from '../screens/drop-off-confirm-open-slot/drop-off-confirm-open-slot.component';
import DropOffConfirmOpenSlotsParallel from '../screens/drop-off-confirm-open-slots-parallel/drop-off-confirm-open-slots-parallel.component';
import DropOffConfirmOpenSlotsSerial from '../screens/drop-off-confirm-open-slots-serial/drop-off-confirm-open-slots-serial.component';
import DropOffConfirmed from '../screens/drop-off-confirmed/drop-off-confirmed.component';
import DropOffMethod from '../screens/drop-off-method/drop-off-method.component';
import DropOffPinCode from '../screens/drop-off-pin-code/drop-off-pin-code.component';
import DropOffScanQrCode from '../screens/drop-off-scan-qr-code/drop-off-scan-qr-code.component';
import EnterTrackingNumber from '../screens/enter-tracking-number/enter-tracking-number.component';
import { EquipmentReturnLost } from '../screens/equipment-return-lost/equipment-return-lost.component';
import FablabDropOffConfirmOpenSlot from '../screens/fablab-drop-off-confirm-open-slot/fablab-drop-off-confirm-open-slot.component';
import FablabScanQrCode from '../screens/fablab-scan-qr-code/fablab-scan-qr-code.component';
import FablabSelectReceivers from '../screens/fablab-select-receivers/fablab-select-receivers.component';
import IdentifyBadge from '../screens/identify-badge/identify-badge.component';
import IdentifyUser from '../screens/identify-user/identify-user.component';
import ItsmeQrAuthentication from '../screens/itsme-qr-authentication/itsme-qr-authentication.component';
import { KitReturnMethod } from '../screens/kit-return-method/kit-return-method.component';
import LendingPickByState from '../screens/lending-pick-by-state/lending-pick-by-state.component';
import LendingReturnAvailableDetail from '../screens/lending-return-available-detail/lending-return-available-detail.component';
import LendingReviewDetail from '../screens/lending-review-detail/lending-review-detail.component';
import LendingReviewOverview from '../screens/lending-review-overview/lending-review-overview.component';
import LendingReviewResolve from '../screens/lending-review-resolve/lending-review-resolve.component';
import LinkBadgeConfirmed from '../screens/link-badge-confirmed/link-badge-confirmed.component';
import LinkBadge from '../screens/link-badge/link-badge.component';
import ManageGates from '../screens/manage-gates/manage-gates.component';
import OpenDropOffConfirmOpenSlot from '../screens/open-drop-off-confirm-open-slot/open-drop-off-confirm-open-slot.component';
import OpenDropOffScanCourierTrackAndTrace from '../screens/open-drop-off-scan-courier-track-and-trace/open-drop-off-scan-courier-track-and-trace.component';
import OpenDropOffScanQrCode from '../screens/open-drop-off-scan-qr-code/open-drop-off-scan-qr-code.component';
import PickUpBy from '../screens/pick-up-by/pick-up-by.component';
import PickUpConfirmOpenSlot from '../screens/pick-up-confirm-open-slot/pick-up-confirm-open-slot.component';
import PickUpConfirmOpenSlotsParallel from '../screens/pick-up-confirm-open-slots-parallel/pick-up-confirm-open-slots-parallel.component';
import PickUpConfirmOpenSlotsSerial from '../screens/pick-up-confirm-open-slots-serial/pick-up-confirm-open-slots-serial.component';
import PickUpConfirmed from '../screens/pick-up-confirmed/pick-up-confirmed.component';
import PickUpMethod from '../screens/pick-up-method/pick-up-method.component';
import PickUpOverview from '../screens/pick-up-overview/pick-up-overview.component';
import PickUpPinCode from '../screens/pick-up-pin-code/pick-up-pin-code.component';
import PickUpScanParcels from '../screens/pick-up-scan-parcels/pick-up-scan-parcels.component';
import PickUpScanQrCode from '../screens/pick-up-scan-qr-code/pick-up-scan-qr-code.component';
import PickUp from '../screens/pick-up/pick-up.component';
import PrintLabels from '../screens/print-labels/print-labels.component';
import ProcessOpenCloseSlot from '../screens/process-open-close-slot/process-open-close-slot.component';
import ProcessOpenCloseSlots from '../screens/process-open-close-slots/process-open-close-slots.component';
import { ProcessOpenCloseSpotLayout } from '../screens/process-open-close-spot-layout/process-open-close-spot-layout.component';
import ProveIdentity from '../screens/prove-identity/prove-identity.component';
import RecycleOverview from '../screens/recycle-overview/recycle-overview.component';
import { ReplenishDetail } from '../screens/replenish-detail/replenish-detail.component';
import { ReplenishOverview } from '../screens/replenish-overview/replenish-overview.component';
import RequestServices from '../screens/request-services/request-services.component';
import ResetBadgeConfirmed from '../screens/reset-badge-confirmed/reset-badge-confirmed.component';
import ResetBadge from '../screens/reset-badge/reset-badge.component';
import { ReturnDetail } from '../screens/return-detail/return-detail.component';
import ReturnEquipmentList from '../screens/return-equipment-list/return-equipment-list.component';
import ReturnOverview from '../screens/return-overview/return-overview.component';
import ReviewDetail from '../screens/review-detail/review-detail.component';
import ReviewRecyclesConfirmOpenSlot from '../screens/review-recycles-confirm-open-slot/review-recycles-confirm-open-slot.component';
import ReviewRecycles from '../screens/review-recycles/review-recycles.component';
import ReviewResolve from '../screens/review-resolve/review-resolve.component';
import ReviewReturns from '../screens/review-returns/review-returns.component';
import WizardScreenNotFound from '../screens/screen-not-found/screen-not-found.component';
import { SelectAttributes } from '../screens/select-attributes/select-attributes.component';
import { SelectCostCenter } from '../screens/select-cost-center/select-cost-center.component';
import SelectCourier from '../screens/select-courier/select-courier.component';
import SelectGroupedReceivers from '../screens/select-grouped-receivers/select-grouped-receivers.component';
import { SelectOrderDeliveryLocation } from '../screens/select-order-delivery-location/select-order-delivery-location.component';
import { SelectQuantity } from '../screens/select-quantity/select-quantity.component';
import SelectReceivers from '../screens/select-receivers/select-receivers.component';
import SelectSendersAndReceivers from '../screens/select-senders-and-receivers/select-senders-and-receivers.component';
import { SetCurrentUserAsSender } from '../screens/set-current-user-as-sender/set-current-user-as-sender.component';
import VerifyContactInformation from '../screens/verify-contact-information/verify-contact-information.component';
import VerifyCurrentLocation from '../screens/verify-current-location/verify-current-location.component';
import WearableReturnReason from '../screens/wearable-return-reason/wearable-return-reason.component';
import useScreenRenderer from './screen-renderer.controller';

const ScreenRenderer = () => {
    const viewProps = useScreenRenderer();

    if (viewProps.isLoading || !viewProps.currentWizardState) {
        return (
            <div
                className='bg-background-default flex h-dvh flex-col'
                id={'wizard-screen-renderer-loading'}>
                <WizardNavigationHeader title={'...'} />
                <div className='my-6 flex h-full w-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            </div>
        );
    }

    switch (viewProps.screen_type) {
        case ScreenType.CONFIRM_CURRENT_LOCATION:
            return <ConfirmCurrentLocation />;
        case ScreenType.CONFIRM_CURRENT_DEVICE_LOCATION:
            return <ConfirmCurrentDeviceLocation />;
        case ScreenType.CONTINUE_TO_LOCATION:
            return <ContinueToLocation />;
        case ScreenType.CONFIRM_PICK_UP:
            return <ConfirmPickUp />;
        case ScreenType.PICK_UP_BY:
            return <PickUpBy />;
        case ScreenType.PICK_UP_SCAN_PARCELS:
            return <PickUpScanParcels />;
        case ScreenType.PICK_UP_OVERVIEW:
            return <PickUpOverview />;
        case ScreenType.PICK_UP:
            return <PickUp />;
        case ScreenType.PRINT_LABELS:
            return <PrintLabels />;
        case ScreenType.PROCESS_OPEN_CLOSE_SLOT:
        case ScreenType.PROCESS_OPEN_CLOSE_SLOT_DROP_OFF:
        case ScreenType.PROCESS_OPEN_CLOSE_SLOT_PICK_UP:
        case ScreenType.PROCESS_OPEN_CLOSE_SLOT_SHOP:
        case ScreenType.PROCESS_OPEN_CLOSE_SLOT_RETURN:
        case ScreenType.PROCESS_OPEN_CLOSE_SLOT_REVIEW:
            return <ProcessOpenCloseSlot />;
        case ScreenType.PROCESS_OPEN_CLOSE_SLOTS:
            return <ProcessOpenCloseSlots />;
        case ScreenType.DROP_OFF_METHOD:
            return <DropOffMethod />;
        case ScreenType.AUTHENTICATED_DROP_OFF_METHOD:
            return <AuthenticatedDropOffMethod />;
        case ScreenType.DROP_OFF_PIN_CODE:
            return <DropOffPinCode />;
        case ScreenType.DROP_OFF_SCAN_QR_CODE:
            return <DropOffScanQrCode />;
        case ScreenType.ENTER_TRACKING_NUMBER:
            return <EnterTrackingNumber />;
        case ScreenType.DROP_OFF_CONFIRM_OPEN_SLOT:
            return <DropOffConfirmOpenSlot />;
        case ScreenType.DROP_OFF_CONFIRM_OPEN_SLOTS_PARALLEL:
            return <DropOffConfirmOpenSlotsParallel />;
        case ScreenType.DROP_OFF_CONFIRM_OPEN_SLOTS_SERIAL:
            return <DropOffConfirmOpenSlotsSerial />;
        case ScreenType.DROP_OFF_CONFIRMED:
            return <DropOffConfirmed />;
        case ScreenType.ITSME_QR_AUTHENTICATION:
            return <ItsmeQrAuthentication />;
        case ScreenType.PROVE_IDENTITY:
            return <ProveIdentity mode='both' />;
        case ScreenType.PROVE_IDENTITY_BADGE:
            return <ProveIdentity mode='badge' />;
        case ScreenType.PROVE_IDENTITY_ITSME:
            return <ProveIdentity mode='itsme' />;
        case ScreenType.CREATE_AUDIT_TRANSACTION:
            return <CreateAuditTransaction />;
        case ScreenType.OPEN_DROP_OFF_SCAN_QR_CODE:
            return <OpenDropOffScanQrCode />;
        case ScreenType.OPEN_DROP_OFF_SCAN_COURIER_TRACK_AND_TRACE:
            return <OpenDropOffScanCourierTrackAndTrace />;
        case ScreenType.OPEN_DROP_OFF_CONFIRM_OPEN_SLOT:
            return <OpenDropOffConfirmOpenSlot />;
        case ScreenType.FABLAB_SCAN_QR_CODE:
            return <FablabScanQrCode />;
        case ScreenType.FABLAB_SELECT_RECEIVERS:
            return <FablabSelectReceivers />;
        case ScreenType.FABLAB_DROP_OFF_CONFIRM_OPEN_SLOT:
            return <FablabDropOffConfirmOpenSlot />;
        case ScreenType.CREATE_RECEIVER:
            return <CreateReceiver />;
        case ScreenType.SET_CURRENT_USER_AS_SENDER:
            return <SetCurrentUserAsSender />;
        case ScreenType.AUTHENTICATED_PICK_UP_METHOD:
            return <AuthenticatedPickUpMethod />;
        case ScreenType.PICK_UP_METHOD:
            return <PickUpMethod />;
        case ScreenType.PICK_UP_PIN_CODE:
            return <PickUpPinCode />;
        case ScreenType.PICK_UP_SCAN_QR_CODE:
            return <PickUpScanQrCode />;
        case ScreenType.PICK_UP_CONFIRM_OPEN_SLOT:
            return <PickUpConfirmOpenSlot />;
        case ScreenType.PICK_UP_CONFIRM_OPEN_SLOTS_PARALLEL:
            return <PickUpConfirmOpenSlotsParallel />;
        case ScreenType.PICK_UP_CONFIRM_OPEN_SLOTS_SERIAL:
            return <PickUpConfirmOpenSlotsSerial />;
        case ScreenType.PICK_UP_CONFIRMED:
            return <PickUpConfirmed />;
        case ScreenType.SELECT_COURIER:
            return <SelectCourier />;
        case ScreenType.SELECT_RECEIVERS:
            return <SelectReceivers />;
        case ScreenType.SELECT_GROUPED_RECEIVERS:
            return <SelectGroupedReceivers />;
        case ScreenType.SELECT_SENDERS_AND_RECEIVERS:
            return <SelectSendersAndReceivers />;
        case ScreenType.BROWSE_PRODUCTS_BY_CATEGORIES:
            return <BrowseProductsByCategories />;
        case ScreenType.SELECT_ATTRIBUTES:
            return <SelectAttributes />;
        case ScreenType.SELECT_QUANTITY:
            return <SelectQuantity />;
        case ScreenType.SELECT_COST_CENTER:
            return <SelectCostCenter />;
        case ScreenType.SELECT_ORDER_DELIVERY_LOCATION:
            return <SelectOrderDeliveryLocation />;
        case ScreenType.BASKET_OVERVIEW:
            return <BasketOverview />;
        case ScreenType.CONFIRM_ORDER:
            return <ConfirmOrder />;
        case ScreenType.CONSUME_KIT:
            return <ConsumeKit />;
        case ScreenType.CONFIRM_LENDING:
        case ScreenType.CONFIRM_SHOP_TRANSACTION:
            return <ConfirmShopTransaction />;
        case ScreenType.WEARABLE_RETURN_REASON:
            return <WearableReturnReason />;
        case ScreenType.REQUEST_SERVICES:
            return <RequestServices />;
        case ScreenType.VERIFY_CONTACT_INFORMATION:
            return <VerifyContactInformation />;
        case ScreenType.VENDING_RETURN_OVERVIEW:
        case ScreenType.LENDING_RETURN_OVERVIEW:
        case ScreenType.RETURN_OVERVIEW:
            return <ReturnOverview />;
        case ScreenType.LENDING_RETURN_AVAILABLE_DETAIL:
            return <LendingReturnAvailableDetail />;
        case ScreenType.LENDING_REVIEW_OVERVIEW:
            return <LendingReviewOverview />;
        case ScreenType.LENDING_REVIEW_DETAIL:
            return <LendingReviewDetail />;
        case ScreenType.LENDING_REVIEW_RESOLVE:
            return <LendingReviewResolve />;
        case ScreenType.LENDING_PICK_BY_STATE:
            return <LendingPickByState />;
        case ScreenType.LENDING_RETURN_DETAIL:
        case ScreenType.VENDING_RETURN_DETAIL:
        case ScreenType.RETURN_DETAIL:
            return <ReturnDetail />;
        case ScreenType.KIT_RETURN_METHOD:
            return <KitReturnMethod />;
        case ScreenType.CONFIRM_KIT_RETURN:
            return <ConfirmKitReturn />;
        case ScreenType.CONFIRM_KIT_RETURN_SLOT:
            return <ConfirmKitReturnSlot />;
        case ScreenType.RETURN_EQUIPMENT_LIST:
            return <ReturnEquipmentList />;
        case ScreenType.EQUIPMENT_RETURN_LOST:
            return <EquipmentReturnLost />;
        case ScreenType.CONFIRM_RETURN:
            return <ConfirmReturn />;
        case ScreenType.REVIEW_RETURNS:
            return <ReviewReturns />;
        case ScreenType.REVIEW_DETAIL:
            return <ReviewDetail />;
        case ScreenType.REVIEW_RESOLVE:
            return <ReviewResolve />;
        case ScreenType.REFILL_OVERVIEW:
        case ScreenType.REPLENISH_OVERVIEW:
            return <ReplenishOverview />;
        case ScreenType.REPLENISH_DETAIL:
        case ScreenType.REFILL_DETAIL:
            return <ReplenishDetail />;
        case ScreenType.PROCESS_OPEN_CLOSE_SPOT_LAYOUT:
            return <ProcessOpenCloseSpotLayout />;
        case ScreenType.VERIFY_CURRENT_LOCATION:
            return <VerifyCurrentLocation />;
        case ScreenType.IDENTIFY_USER:
            return <IdentifyUser />;
        case ScreenType.MANAGE_GATES:
            return <ManageGates />;
        case ScreenType.RECYCLE_OVERVIEW:
            return <RecycleOverview />;
        case ScreenType.CREATE_RECYCLE_TRANSACTION:
            return <CreateRecycleTransaction />;
        case ScreenType.REVIEW_RECYCLES:
            return <ReviewRecycles />;
        case ScreenType.REVIEW_RECYCLES_CONFIRM_OPEN_SLOT:
            return <ReviewRecyclesConfirmOpenSlot />;
        case ScreenType.RESET_BADGE:
            return <ResetBadge />;
        case ScreenType.RESET_BADGE_CONFIRMED:
            return <ResetBadgeConfirmed />;
        case ScreenType.LINK_BADGE:
            return <LinkBadge />;
        case ScreenType.LINK_BADGE_CONFIRMED:
            return <LinkBadgeConfirmed />;
        case ScreenType.IDENTIFY_BADGE:
            return <IdentifyBadge />;
        default:
            return <WizardScreenNotFound />;
    }
};

export default ScreenRenderer;
